export default "__VITE_ASSET__9c07497f__"